/* eslint-disable camelcase */
import common_en from './en/common.json';
import common_fr from './fr/common.json';
import common_nl from './nl/common.json';

export default {
    en: {
        common: common_en,
    },
    fr: {
        common: common_fr,
    },
    nl: {
        common: common_nl,
    },
};
